(function () {
  if (window.__ocCart) return;
  window.__ocCart = true;

  var KEY = 'oc_cart_timer_end', LEN = 15 * 60 * 1000;
  function end() {
    var e = 0;
    try { e = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (x) {}
    if (!e || e < Date.now()) { e = Date.now() + LEN; try { sessionStorage.setItem(KEY, String(e)); } catch (x) {} }
    return e;
  }
  function tick() {
    var els = document.querySelectorAll('[data-oc-timer]');
    if (!els.length) return;
    var left = Math.max(0, Math.round((end() - Date.now()) / 1000));
    var t = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== t) els[i].textContent = t;
  }
  tick();
  setInterval(tick, 1000);
  var drawer = document.getElementById('CartDrawer');
  if (drawer && window.MutationObserver) new MutationObserver(tick).observe(drawer, { childList: true, subtree: true });

  // Quantity changes in the drawer: update straight away (no 300 ms wait) and treat 0 as "remove".
  // Dawn's own validation looks for the cart-page input (#Quantity-n) and crashes in the drawer.
  var pending = null, lastBtn = 'plus';
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#CartDrawer .quantity__button');
    if (b) lastBtn = b.name;
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
    var items = input.closest('#CartDrawer cart-drawer-items');
    if (!items || typeof items.updateQuantity !== 'function') return;
    e.stopPropagation();
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && qty > max) qty = max;
      var active = document.activeElement;
      var name = active === input ? 'updates[]' : lastBtn;
      items.updateQuantity(input.dataset.index, qty, { target: input, currentTarget: null }, name, input.dataset.quantityVariantId);
    }, 80);
  }, true);
})();
